import { Link } from "react-router-dom";
import { ArrowLeft } from "lucide-react";
import { StaggerGroup, StaggerItem } from "@/components/Reveal";
import { BRANDS_WORKED_WITH } from "@/lib/siteData";

export default function Brands() {
  return (
    <div>
      <section className="pt-28 md:pt-36 pb-8 md:pb-10 container-x" data-testid="brands-page-heading">
        <p className="text-xs md:text-sm tracking-[0.35em] uppercase font-bold text-gold mb-5">Our Partners</p>
        <h1 className="font-display uppercase text-offwhite leading-[0.92] tracking-tight text-[14vw] sm:text-[11vw] md:text-8xl lg:text-[7vw]">
          Brands That Trust Us
        </h1>
        <p className="mt-6 max-w-2xl text-white/60 font-light leading-relaxed text-base md:text-lg">
          A selection of the brands we have collaborated with across ad films, movie associations and
          celebrity campaigns.
        </p>
      </section>

      <section className="pb-16 md:pb-20 container-x" data-testid="brands-grid">
        <StaggerGroup instant className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-5 gap-5 md:gap-6">
          {BRANDS_WORKED_WITH.map((b, i) => (
            <StaggerItem key={`${b.name}-${i}`}>
              <div
                data-testid={`brand-card-${i}`}
                className="group flex flex-col items-center"
              >
                <div className="w-full aspect-[4/3] bg-white rounded-xl shadow-lg flex items-center justify-center p-5 md:p-6 transition-transform duration-500 group-hover:-translate-y-1 group-hover:shadow-[0_20px_50px_-15px_rgba(0,0,0,0.8)]">
                  <img
                    src={b.logo}
                    alt={b.name}
                    loading="lazy"
                    className="max-h-full max-w-full w-auto object-contain"
                  />
                </div>
                <p className="mt-3 text-center text-xs md:text-sm uppercase tracking-[0.15em] text-white/70">
                  {b.name}
                </p>
              </div>
            </StaggerItem>
          ))}
        </StaggerGroup>

        <div className="mt-16 text-center">
          <Link
            to="/"
            data-testid="brands-back-home"
            className="inline-flex items-center gap-2 border border-gold text-gold px-8 py-3 uppercase tracking-[0.2em] text-xs font-semibold hover:bg-gold hover:text-void transition-colors"
          >
            <ArrowLeft size={15} /> Back Home
          </Link>
        </div>
      </section>
    </div>
  );
}
